import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnlineexamListComponent } from './onlineexam-list/onlineexam-list.component';
import { OnlineexamCreateComponent } from './onlineexam-create/onlineexam-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: OnlineexamListComponent,
        data: {
          title: "Onlineexam List",
          breadcrumb: "Onlineexam List"
        }
      },
      {
        path: 'create',
        component: OnlineexamCreateComponent,
        data: {
          title: "Create Onlineexam",
          breadcrumb: "Create Onlineexam"
        }
      },
      {
        path: 'edit/:id',
        component: OnlineexamCreateComponent,
        data: {
          title: "Edit Onlineexam",
          breadcrumb: "Edit Onlineexam"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class OnlineexamRoutingModule { }
